import axios from 'axios';
import Parse from 'parse';
import { getUrl } from '../utils';
import { actionWithLoader } from './utils';
import { filterByPack, setPack } from './packs';

export const Decoration = Parse.Object.extend('Decoration');

const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(getUrl() + '/api/uploadDecoration', formData);
  return response.data?.fileName;
};

export const getDecorationsPerPage = (limit = 10, skip = 0, filter = '', packId) => {
  return async (dispatch) => {
    const query = new Parse.Query(Decoration).include('pack').notEqualTo('deleted', true).limit(limit).skip(skip).descending('updatedAt').withCount(true);
    if (filter !== '') {
      query.contains('title', filter);
    }
    filterByPack(query, packId);
    const decorations = await query.find();
    dispatch({ type: 'GET_DECORATIONS', decorations: decorations.results.map((decoration) => decoration.toJSON()), count: decorations.count });
  };
};

export const createDecoration = (values) => {
  return actionWithLoader(async (dispatch) => {
    const decoration = new Decoration();
    decoration.set('title', values.title);
    decoration.set('description', values.description);
    setPack(decoration, values.pack);
    // Last in the list: the app gives new stickers the first decoration.
    decoration.set('order', await new Parse.Query(Decoration).notEqualTo('deleted', true).count());
    if (values.image instanceof File) {
      decoration.set('image', await uploadImage(values.image));
    }
    await decoration.save();
    dispatch({ type: 'ADD_DECORATION', payload: decoration.toJSON() });
  });
};

export const deleteDecoration = (id) => {
  return actionWithLoader(async (dispatch) => {
    const decoration = await new Parse.Query(Decoration).get(id);
    decoration.set('deleted', true);
    await decoration.save();
    dispatch({ type: 'DELETE_DECORATION', id });
  });
};

export const editDecoration = (id) => {
  return async (dispatch) => {
    const decoration = await new Parse.Query(Decoration).include('pack').get(id);
    dispatch({ type: 'EDIT_DECORATION', decoration: decoration.toJSON() });
  };
};

export const updateDecoration = (decoration, values) => {
  return actionWithLoader(async (dispatch) => {
    const updated = new Decoration();
    updated.id = decoration.objectId;
    updated.set('title', values.title);
    updated.set('description', values.description);
    if (values.image instanceof File) {
      updated.set('image', await uploadImage(values.image));
    }
    setPack(updated, values.pack);
    await updated.save();
    dispatch({ type: 'UPDATE_DECORATION', decoration: updated.toJSON() });
  });
};

export const reorderDecorations = (values) => {
  return async (dispatch) => {
    const saved = await Promise.all(
      values.map((item, index) => {
        const decoration = new Decoration();
        decoration.id = item.objectId;
        decoration.set('order', index);
        return decoration.save();
      })
    );
    dispatch({ type: 'REORDER_DECORATIONS', decorations: saved.map((item) => item.toJSON()) });
  };
};
